const customScrollbar = {
  init ($anchorElement) {
    return $anchorElement.perfectScrollbar()
  },
  update ($anchorElement) {
    return $anchorElement.perfectScrollbar('update')
  },

  /**
    * @param {element} - element on which scrollbar needs to be applied
    * @desc - promise function that first removing scrollbar instance and then call it again. Reason: official lib problem.
    *
   **/
  rebuildScroll ($anchorElement) {
    return new Promise(function(resolve) {
      $anchorElement.perfectScrollbar('destroy')
      resolve()
    }).then(function() {
      customScrollbar.init($anchorElement)
    }).catch(e => log.error(e.message))
  },
}

module.exports = customScrollbar




// WEBPACK FOOTER //
// ./src/modules/customScrollbar.js